import { render } from "./EmployeeLeave.vue?vue&type=template&id=5f0c0840&scoped=true"
import script from "./EmployeeLeave.vue?vue&type=script&lang=js"
export * from "./EmployeeLeave.vue?vue&type=script&lang=js"

import "./EmployeeLeave.vue?vue&type=style&index=0&id=5f0c0840&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0c0840"]])

export default __exports__